import { DateOfBirth, FirstName, Siren, SurName } from "./SigninFormFields";
import { dateOfBirthValidation, firstNameValidation, sirenValidation, surNameValidation } from "./SignInFormValidation";

export const smeValidationSchema = () => firstNameValidation().concat(surNameValidation()).concat(dateOfBirthValidation()).concat(sirenValidation())

export const SmeFieldset = () =>
  <>
    <FirstName />
    <SurName />
    <DateOfBirth />
    <Siren />
  </>